<style lang="less" rel="stylesheet/less">
    .article-wrapper{
        padding:0 20px;
    }
    ._title{
        font-size:20px;
        color:#333;
        padding:20px 0 ;
        line-height:1.5em;
    }
    .article-desc{
        border-bottom:1px solid #ccc;
        padding-bottom:15px;
        margin-bottom:20px;
    }

    .external_content{
        /*margin:0 20px;*/
        padding-bottom:100px;
        line-height:1.7em;
        img{
            max-width:100%;
        }
    }
</style>
<template>
    <div class="article-wrapper" v-if="obj">
        <h2 class="_title">{{obj.title}}</h2>
        <p class="article-desc">来源:{{obj.source}} {{timeDisplay(obj.publish_time*1000)}}</p>
        <hr>
        <div class="external_content" v-html="obj.content">

        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import api from '../lib/api';
    import moment from 'moment';

    export default {
        data() {
            return {
                obj:null
            }
        },
        computed: {},
        methods: {
            init(){
                let id = this.$route.query.id;
                api.getArticleDetail(id).then(res=>{
                    this.obj = res;
                })
            },
            timeDisplay(tm){
                return moment(tm).format('YYYY-MM-DD');
            }
        },
        components: {},
        mounted() {
            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// article-detail.vue?37a3d678